import React from 'react';
import { Target, Eye, Users, Award } from 'lucide-react';
import { profileData } from '../data/mock';

export const Profile = () => {
  return (
    <section id="profil" className="py-20 px-4" style={{ background: 'var(--bg-page)' }}>
      <div className="container mx-auto max-w-6xl">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-4">Tentang IndoHukum.id</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            {profileData.description}
          </p>
        </div>

        {/* Vision & Mission Grid */}
        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {/* Vision Card */}
          <div className="voice-card accent-purple">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                   style={{ background: 'rgba(152, 125, 156, 0.2)' }}>
                <Eye size={24} style={{ color: 'var(--accent-purple-400)' }} />
              </div>
              <div>
                <h3 className="heading-3 mb-2">Visi Kami</h3>
                <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                  {profileData.vision}
                </p>
              </div>
            </div>
          </div>

          {/* Mission Card */}
          <div className="voice-card accent-blue">
            <div className="flex items-start gap-4 mb-4">
              <div className="w-12 h-12 rounded-full flex items-center justify-center" 
                   style={{ background: 'rgba(118, 133, 151, 0.2)' }}>
                <Target size={24} style={{ color: 'var(--accent-blue-400)' }} />
              </div>
              <div>
                <h3 className="heading-3 mb-3">Misi Kami</h3>
                <ul className="space-y-2">
                  {profileData.mission.map((item, index) => (
                    <li key={index} className="body-small flex items-start gap-2" style={{ color: 'var(--text-secondary)' }}>
                      <span style={{ color: 'var(--accent-blue-400)' }}>•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Key Features */}
        <div className="grid md:grid-cols-3 gap-6">
          <div className="voice-card text-center hover-lift">
            <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" 
                 style={{ background: 'var(--accent-orange-200)' }}>
              <Award size={28} style={{ color: 'var(--accent-orange-400)' }} />
            </div>
            <h4 className="heading-3 mb-2">Keahlian Terpercaya</h4>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              Tim ahli hukum berpengalaman dengan pemahaman mendalam regulasi Indonesia
            </p>
          </div>

          <div className="voice-card text-center hover-lift">
            <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" 
                 style={{ background: 'var(--accent-pink-200)' }}>
              <Users size={28} style={{ color: '#987D9C' }} />
            </div>
            <h4 className="heading-3 mb-2">Teknologi AI Canggih</h4>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              Menggunakan AI terkini untuk analisis cepat dan akurat
            </p>
          </div>

          <div className="voice-card text-center hover-lift">
            <div className="w-16 h-16 rounded-full mx-auto mb-4 flex items-center justify-center" 
                 style={{ background: 'var(--accent-green-200)' }}>
              <Target size={28} style={{ color: '#768597' }} />
            </div>
            <h4 className="heading-3 mb-2">Solusi Komprehensif</h4>
            <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
              Dari konsultasi hingga pembuatan kebijakan dalam satu platform
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
